import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsEmailRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-email',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
	exact: true,
};
